import axios from 'axios';
import { SERVER_ADDRESS } from '../../settings';

async function GetSettingValues(TOKEN, Code) {
    return await axios.get(`${SERVER_ADDRESS}/api/Common/GetSettingValue?Code=${Code}`, {
        headers: {
            Authorization: `Bearer ${TOKEN}`
        }
    });
}

const Settings = {
    SMTP_Host: "SMTP_Host",
    SMTP_DefaultCredentials: "SMTP_DefaultCredentials",
    SMTP_Username: "SMTP_Username",
    SMTP_Password: "SMTP_Password",
    SMTP_From: "SMTP_From",
    SMTP_Port: "SMTP_Port",
    SMTP_Ssl: "SMTP_Ssl",
    License: "License",
    CCCNrIsActive: "CCCNrIsActive",
    UserCanChangeBankData: "UserCanChangeBankData",
    FileSystemUserName: "FileSystemUserName",
    FileSystemUserPwd: "FileSystemUserPwd",
    FileSystemStorageActive: "FileSystemStorageActive",
    GoogleGriveUserName: "GoogleGriveUserName",
    GoogleDrivePwd: "GoogleDrivePwd",
    GoogleDriveStorageActive: "GoogleDriveStorageActive",
    PowerBIUserName: "PowerBIUserName",
    PowerBIUserPassword: "PowerBIUserPassword",
    PowerBIAuthorityUrl: "PowerBIAuthorityUrl",
    PowerBIResourceUrl: "PowerBIResourceUrl",
    PowerBIApplicationId: "PowerBIApplicationId",
    PowerBIApiUrl: "PowerBIApiUrl",
    PowerBIWorkspaceId: "PowerBIWorkspaceId",
    PowerBIDashboardId: "PowerBIDashboardId",
    PowerBIContractsId: "PowerBIContractsId",
    PowerBIContractsGeoId: "PowerBIContractsGeoId",
    PowerBITransportsId: "PowerBITransportsId",
    PowerBIStocksId: "PowerBIStocksId",
    PowerBITeamsId: "PowerBITeamsId",
    MyTicketsAuth: "MyTicketsAuth",
    filter_InvoiceCurrMonth: "filter_InvoiceCurrMonth",
    filter_InvoiceDaySpan: "filter_InvoiceDaySpan",
    filter_CreditMemoCurrMonth: "filter_CreditMemoCurrMonth",
    filter_CreditMemoDaySpan: "filter_CreditMemoDaySpan",
    filter_CurrAccCurrMonth: "filter_CurrAccCurrMonth",
    filter_CurrAccDaySpan: "filter_CurrAccDaySpan",
    filter_ShipmentCurrMonth: "filter_ShipmentCurrMonth",
    filter_ShipmentDaySpan: "filter_ShipmentDaySpan",
    filter_TripCurrMonth: "filter_TripCurrMonth",
    filter_TripDaySpan: "filter_TripDaySpan",
    filter_ContractLineCurrMonth: "filter_ContractLineCurrMonth",
    filter_ContractLineDaySpan: "filter_ContractLineDaySpan",
    filter_ServicesCurrMonth: "filter_ServicesCurrMonth",
    filter_ServicesDaySpan: "filter_ServicesDaySpan",
    filter_OtherDocsCurrMonth: "filter_OtherDocsCurrMonth",
    filter_OtherDocsDaySpan: "filter_OtherDocsDaySpan",
    ExpirationDaySpan: "ExpirationDaySpan",
    TwoFactorActive: "TwoFactorActive",
    TwoFactorTimeSpan: "TwoFactorTimeSpan",
    TwoFactorUsersCanChange: "TwoFactorUsersCanChange",
    AdminEmail: "AdminEmail",
    GlobalSearchActive: "GlobalSearchActive",
    RememberMeActive: "RememberMeActive",
    RecoverPasswordActive: "RecoverPasswordActive",
    ChatUrl: "ChatUrl",
    UsesIframe: "UsesIframe",
    HideNotifications: "HideNotifications",
    HideChat: "HideChat",
    GoogleSheetId: "GoogleSheetId",
    HideGDPR: "HideGDPR",
    IDBoxTokenURL: "IDBoxTokenURL",
    IDBoxDefaultWebsiteURL: "IDBoxDefaultWebsiteURL",
    IDBoxTokenWebsiteURL: "IDBoxTokenWebsiteURL",
    RequestAndClaimsIframeLink: "RequestAndClaimsIframeLink",
    DataStudioActive: "DataStudioActive",
    PowerBIActive: "PowerBIActive",
    DataStudioUrl: "DataStudioUrl",
    DataStudioDashboardId: "DataStudioDashboardId",
    QlikSenseActive: "QlikSenseActive"
};

export {
    Settings,
    GetSettingValues
};
